import { ChangeEvent } from 'react';

interface CheckboxProps {
  label?: string;
  type?: string;
  name: string;
  id?: string;
  checked?: boolean;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  placeholder?: string;
  value?: string | number;
  onChange?(e: ChangeEvent<HTMLInputElement>): void;
  indeterminate?: boolean;
  className?: string;
}

const Checkbox = ({
  label = '',
  name = '',
  id,
  checked = false,
  required = false,
  disabled = false,
  value,
  onChange,
  indeterminate,
  className
}: CheckboxProps) => {
  const requiredMarker = required ? (
    <>
      &nbsp;
      <span className="text-danger">*</span>
    </>
  ) : null;

  return (
    <label
      className={`custom-control custom-checkbox align-items-center ${className}`}
    >
      <input
        className="custom-control-input"
        id={id}
        name={name}
        type="checkbox"
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        ref={(el) => el && (el.indeterminate = indeterminate as boolean)}
      />
      <span className="custom-control-indicator" />
      <span className="custom-control-description">
        {label}
        {requiredMarker}
      </span>
    </label>
  );
};

export default Checkbox;
